import React from "react";
import {
  Link
} from "react-router-dom";

import Notification from 'rc-notification';
import Modal from './../../../components/modal.js';
import Loading from './../../../components/loading.js';
import config from './../../config.js';
let notification = null;
Notification.newInstance({
  style: {
    top: '45px',
    right: 0
  }
}, (n) => notification = n);

export default class ListUser extends React.Component {
  constructor(props) {
    super(props);
    let user = {};
    if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
      user = JSON.parse(localStorage.user);
    }

    this.state = {
      page_title: '用户管理',
      user: user,
      users: [],
      user_size: 0,
      loading: false,
      current_user: '',
      ismodal_edit: false,
      ismodal_config: false,
      modal_title: '修改用户资料'
    };

    document.title = this.state.page_title;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.modalClose = this.modalClose.bind(this);
    this.modalSubmit_edit = this.modalSubmit_edit.bind(this);
    this.modalSubmit_config = this.modalSubmit_config.bind(this);
    this.adduser = this.adduser.bind(this);

  }
  componentDidMount() {
    this.getUsers();
  }
  getUsers() {
    const me = this;
    const {
      user
    } = me.state;
    const postdata = {
      type: 'getuserlist',
      managerlevel: user.level,
      companyid: user.company_id,
      Authorization: localStorage.token
    };
    me.setState({
      loading: true
    });
    fetch(config.host + '/manager/index', {
      method: 'post',
      body: JSON.stringify(postdata)
    })
      .then(res => res.json())
      .then(json => {
        if (json.status === 1) {
          me.setState({
            users: json.data,
            user_size: json.size
          });
        }
        me.setState({
          loading: false
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }


  modaledit(user) {
    user.password = '';
    this.setState({
      current_user: user,
      ismodal_edit: true,
      modal_title: '修改用户资料'
    })
  }


  modalClose() {
    this.setState({
      current_user: '',
      ismodal_edit: false,
      ismodal_config: false,
      loading: false
    })
  }

  modalSubmit_edit() {
    const me = this;
    const {
      user,
      users,
      current_user
    } = me.state;
    if (current_user.id === 0 && current_user.password === '') {
      me.notify('新用户：请输入初始密码');
      return;
    }
    const postdata = Object.assign(this.state.current_user, {
      type: 'update_user',
      managerlevel: user.level,
      companyid: user.company_id,
      Authorization: localStorage.token
    });
    me.setState({
      loading: true
    });
    fetch(config.host + '/manager/index', {
      method: 'post',
      body: JSON.stringify(postdata)
    })
      .then(res => res.json())
      .then(json => {
        me.notify(json.message);

        if (json.status === 1) {
          if (current_user.id > 0) {
            users.forEach((u) => {
              if (u.id === current_user.id) {
                u = current_user;
              }
            });
          }
          if (current_user.id === 0) {
            users.push(json.data);
          }
          me.setState({
            users: users
          });
          me.modalClose();
        }
        me.setState({
          loading: false
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  handleInputChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    let current_user = Object.assign(this.state.current_user, {
      [name]: value
    });
    this.setState({
      current_user: current_user
    });
  }



  notify(message) {
    notification.notice({
      content: <span>{message}</span>,
      duration: 4,
      style: {
        'bottom': 0,
        'right': 0
      }
    });
  }

  update_status(item) {
    const me = this;
    const {
      user,
      users
    } = me.state;

    item.status = item.status === '1' ? '0' : '1';
    const postdata = {
      type: 'update_user_status',
      managerlevel: user.level,
      companyid: user.company_id,
      Authorization: localStorage.token,
      userid: item.id,
      status: item.status
    };
    fetch(config.host + '/manager/index', {
      method: 'post',
      body: JSON.stringify(postdata)
    })
      .then(res => res.json())
      .then(json => {
        me.notify(json.message);
        if (json.status === 1) {
          users.forEach((u) => {
            if (u.id === item.id) {
              u = item;
            }
          })
          me.setState({
            users: users
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }


  modalconfig(item) {
    const me = this;
    const {
      user
    } = me.state;

    const postdata = {
      type: 'service_quantity_get',
      managerlevel: user.level,
      companyid: user.company_id,
      Authorization: localStorage.token,
      userid: item.id,
      company_id: item.company_id
    };

    fetch(config.host + '/manager/index', {
      method: 'post',
      body: JSON.stringify(postdata)
    })
      .then(res => res.json())
      .then(json => {
        if (json.status === 1) {
          item.brainlabel = json.data.brainlabel;
          item.vbm = json.data.vbm;
          item.tbss = json.data.tbss;

          this.setState({
            current_user: item,
            ismodal_config: true
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }



  modalSubmit_config() {

    const me = this;
    const {
      user,
      current_user
    } = me.state;
    const postdata = Object.assign(this.state.current_user, {
      type: 'service_quantity_post',
      managerlevel: user.level,
      companyid: user.company_id,
      Authorization: localStorage.token,
      userid: current_user.id
    });
    me.setState({
      loading: true
    });
    fetch(config.host + '/manager/index', {
      method: 'post',
      body: JSON.stringify(postdata)
    })
      .then(res => res.json())
      .then(json => {
        me.notify(json.message);

        if (json.status === 1) {
          me.modalClose();
        }
        me.setState({
          loading: false
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }



  adduser() {
    let user = {
      id: 0,
      email: '',
      realname: '',
      address: '',
      title: '',
      office: '',
      level: 4,
      password: '',
      status: 1
    };
    this.setState({
      current_user: user,
      ismodal_edit: true,
      modal_title: '添加新用户'
    })
  }

  render() {

    return (
      <div>
        <Loading display={this.state.loading} classtype="" />
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 ">
          <h3>{this.state.page_title}  </h3>

          <button className="btn btn-primary btn-sm" onClick={this.adduser}><i className="fa fa-plus small"></i> 添加新用户</button>
        </div>

        <table className="table table-hover text-center">
          <thead className="thead-dark table-sm">
            <tr>
              <th>用户名</th>
              <th>姓名  </th>
              <th>所在单位</th>
              <th>账户级别</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {
              this.state.users.map((item, index) => {
                let level = ''; //  0:administrator,1:manager;2:advanced;3:article;4:normal 
                switch (item.level) {
                  case '0':
                    level = '系统管理员';
                    break;
                  case '1':
                    level = '管理员';
                    break;
                  case '2':
                    level = '高级数据处理';
                    break;
                  case '3':
                    level = '文章编辑';
                    break;
                  case '4':
                    level = '数据处理';
                    break;
                  case '5':
                    level = '特别账户';
                    break;

                }

                let status = item.status === '1' ? <i className="fa fa-toggle-on"></i> : <i className="fa fa-toggle-off"></i>;
                let statusclass = item.status === '1' ? 'text-success' : 'text-danger';
                return (<tr key={index}>
                  <td className="text-left">{item.email}<br /><small className="text-muted" title="最近登录">{item.date_login}</small></td>
                  <td>{item.realname}</td>
                  <td>{item.address} <span className="text-muted">{item.title}</span> <br /><small className="text-muted">{item.office}</small></td>
                  <td>{level}</td>
                  <td>
                    <div className="btn-group  btn-group-sm text-left ml-1 animated fadeInRight">
                      <a className="px-1 text-success" onClick={() => { this.modaledit(item) }} title="编辑用户信息"><i className="fa fa-edit"></i></a>
                      {item.level > '1' && <a className={statusclass + " px-2"} onClick={() => { this.update_status(item) }} title="启用或停用">{status}</a>}
                      {item.level === '4' && item.company_id != 5 &&
                        <a className="px-1 text-success" title="服务设置" onClick={() => { this.modalconfig(item) }}><i className="fa fa-sliders-h"></i> </a>
                      }
                    </div>
                  </td>
                </tr>)
              })
            }
          </tbody>
        </table>

        <Modal title={this.state.modal_title} display={this.state.ismodal_edit} close={this.modalClose} submit={this.modalSubmit_edit} text_submit="保存">
          {
            this.state.current_user !== '' && <div className="form-row">
              <div className="form-group col-6">
                <label className="">电子邮箱：</label>
                <input type="text" className="form-control" placeholder="" name="email" value={this.state.current_user.email} onChange={this.handleInputChange} />
              </div>

              <div className="form-group  col-6">          </div>

              <div className="form-group col-6">
                <label className="">真实姓名：</label>
                <input type="text" className="form-control" placeholder="" name="realname" value={this.state.current_user.realname || ''} onChange={this.handleInputChange} />
              </div>

              <div className="form-group col-6">
                <label className="">所在单位：</label>
                <input type="text" className="form-control" placeholder="" name="address" value={this.state.current_user.address || ''} onChange={this.handleInputChange} />
              </div>

              <div className="form-group col-6">
                <label className="">职位：</label>
                <input type="text" className="form-control" placeholder="" name="title" value={this.state.current_user.title || ''} onChange={this.handleInputChange} />
              </div>

              <div className="form-group  col-6">
                <label className="">部门：</label>
                <input type="text" className="form-control" placeholder="" name="office" value={this.state.current_user.office || ''} onChange={this.handleInputChange} />
              </div>
              {this.state.current_user.level > 1 &&
                <div className="form-group  col-6">
                  <label className="">账户级别：</label>
                  <select name="level" className="form-control" onChange={this.handleInputChange} value={this.state.current_user.level}>
                    <option value="4">数据处理</option>
                    <option value="2">高级数据处理</option>
                    {this.state.user.company_id == 1 && <option value="5">科研账户</option>}
                    <option value="3">文章编辑</option>
                  </select>
                </div>
              }
              <div className="form-group  col-6">
                <label className="">登录密码：</label>
                <input type="text" className="form-control" placeholder="" name="password" value={this.state.current_user.password || ''} onChange={this.handleInputChange} />
              </div>
            </div>
          }
        </Modal>



        <Modal title="用户服务设置" display={this.state.ismodal_config} close={this.modalClose} submit={this.modalSubmit_config} text_submit="保存">
          <form className="form-horizontal">
            <div className="form-group form-row">
              <label className="col-3 text-right">用户：</label>
              <div className="col-9">
                <p className="form-control-static user_email">{this.state.current_user.email}</p>
              </div>
            </div>
            <div className="mx-5 px-5">
              <div className="input-group mb-2 mx-5 px-5">
                <div class="input-group-prepend">
                  <span class="input-group-text">Brainlabel</span>
                </div>
                <input type="number" name="brainlabel" className="form-control" placeholder="" value={this.state.current_user.brainlabel || '10'} required="required" onChange={this.handleInputChange} />
                <div className="input-group-append"><span class="input-group-text">件/每月</span></div>
              </div>

              <div className="input-group mb-2 mx-5 px-5">
                <div class="input-group-prepend">
                  <span class="input-group-text">VBM</span>
                </div>
                <input type="number" name="vbm" className="form-control" placeholder="" value={this.state.current_user.vbm || '10'} required="required" onChange={this.handleInputChange} />
                <div className="input-group-append"><span class="input-group-text">件/每月</span></div>
              </div>


              <div className="input-group mb-2 mx-5 px-5">
                <div class="input-group-prepend">
                  <span class="input-group-text">TBSS</span>
                </div>
                <input type="number" name="tbss" className="form-control" placeholder="" value={this.state.current_user.tbss || '10'} required="required" onChange={this.handleInputChange} />
                <div className="input-group-append"><span class="input-group-text">件/每月</span></div>
              </div>
              <p className="help-block mx-5 px-5">每项服务每月的提交数量</p>


            </div>
          </form>
        </Modal>



      </div>


    );
  }
}


// WEBPACK FOOTER //
// ./src/apps/console/manager/list_user.js